import type { BaseImageTextProps } from './types';

type Theme = NonNullable<BaseImageTextProps['theme']>;

/**
 * Lives outside const.ts on purpose: const.ts imports the variants for the
 * variant map, so a variant importing anything back from const.ts creates an
 * import cycle. That cycle crashed campaign pages (WB-827) with "Cannot access
 * 'ImageAndText' before initialization" — without Header/Footer in the bundle,
 * the chunk is entered from the section side and hits the uninitialized const.
 */
export const imageTextThemeClasses = {
  root: (theme: Theme) => (theme === 'dark' ? 'bg-brand-800' : 'bg-neutral'),
  title: (theme: Theme) => (theme === 'dark' ? 'text-white' : 'text-brand-700'),
  description: (theme: Theme) =>
    theme === 'dark' ? 'content-dark' : 'text-neutral-600',
  legend: (theme: Theme) =>
    theme === 'dark' ? 'text-neutral-100' : 'text-neutral-500',
  legendCard: (theme: Theme) =>
    theme === 'dark'
      ? 'border-brand-600 bg-brand-900'
      : 'border-neutral-100 bg-white',
  legendBorder: (theme: Theme) =>
    theme === 'dark' ? 'border-brand-600' : 'border-neutral-100',
};
